import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  noDashboardsSaved: {
    defaultValue: 'Nenhum dashboard salvo aqui ainda!',
    key: 'dashboard-list-empty-state-noDashboardsSaved',
  },
  organizeDashboards: {
    defaultValue: 'Organize seus dashboards para que você consiga encontrá-los mais facilmente.',
    key: 'dashboard-list-empty-state-organizeDashboards',
  },
  addDashboards: {
    defaultValue: 'Adicionar dashboards',
    key: 'dashboard-list-empty-state-addDashboards',
  },
})
